jQuery(document).ready(function ($) {

    $('.cpc-card-form').on('submit', function (e) {

        e.preventDefault();
        var card_value = $('#card-number').val();
        // if (card_value.trim() === '') {
        //     card_value = 
        // }
        var data = {
            'action': 'feum_validate_card_number',
            'simplistics_nonce': ThemeJS.Variables.Ajax.nonce,
            'card_value': card_value
        };

        var $spinner = $('.js-feum-card-number-spinner');
        $spinner.show();
        //.removeClass('cpc-hidden');

        $('.input-group').hide();

        var $error = $('.feum-validation-msg');
        $error.hide();

        $.post(ThemeJS.Variables.Ajax.url, data, function (res) {

            var response = JSON.parse(res);
            var card = response.card;
            var logo = response.logo;


            // $spinner.addClass('cpc-hidden');

            $spinner.hide();
            $('.input-group').show();

            if (!card) {
                $('.feum-registered-card-num').fadeIn();
                return;
            }
            if (!card.enabled) {
                $('.feum-valid-card-num').fadeIn();
                return;
            }
            if (card.user_id && '0' !== card.user_id) {
                $('.feum-prev-registered-card-num').fadeIn();
                return;
            }

            // $( 'input[name=cpc_card_number]' ).val( card_value );
            $('input[name=cpc_card_number]').val(card_value);

            $('.cpc-magenta-btn.cpc-responsive-width-btn.feum-cpc-form-register-submit').css({ "background-color": response.colors.brand_color_1, "color": "white" });
            $('.cpc-magenta-btn.cpc-responsive-width-btn.feum-cpc-form-register-submit').hover(function () {
                $('#feumRegisterFormModal .cpc-magenta-btn.cpc-responsive-width-btn.feum-cpc-form-register-submit:hover').css({ "background-color": "white", "color": response.colors.brand_color_1 + " !important" });
            }).mouseout(function () {
                $(this).css({ "background-color": response.colors.brand_color_1, "color": "white" });
            });

            $('#feumRegisterFormModal a.underline').css({ 'color': response.colors.brand_color_1 });
            $('#feumRegisterFormModal a.underline').hover(function () {
                $(this).css({ "color": response.colors.brand_color_2, });
            }).mouseout(function () {
                $(this).css({ "color": response.colors.brand_color_1, });
            });

            $('.cpc-company-logo')[0].src = logo;
            $('#feumRegisterFormModal').modal('show');

        });

    });

    $('#card-number').inputmask('999 999 999');

});